import { CHAT_HEIGHT, CHAT_MAX_WIDTH, CHAT_WIDTH } from "./constants";

const minSizeWidth = CHAT_WIDTH;
const minSizeHeight = CHAT_HEIGHT;
let chatWidth = CHAT_WIDTH;
let chatHeight = CHAT_HEIGHT;
let chatPositionX = 0;
let chatPositionY = 0;
let mouseX = 0;
let mouseY = 0;
let resizer;
let element;
let screenWidth;
let screenHeight;

export function resizeChatHandler(el) {
  element = el;

  document.querySelectorAll('.chat__resizer').forEach((currentResizer) => {
    currentResizer.addEventListener('mousedown', /** @param {*} e */(e) => {
      e.preventDefault();

      disableScroll();

      resizer = currentResizer;
      chatWidth = parseFloat(getComputedStyle(element, null).getPropertyValue('width'));
      chatHeight = parseFloat(getComputedStyle(element, null).getPropertyValue('height'));
      chatPositionX = element.getBoundingClientRect().left;
      chatPositionY = element.getBoundingClientRect().top;
      mouseX = e.pageX;
      mouseY = e.pageY;
      screenHeight = window.innerHeight || document.documentElement.clientHeight || document.documentElement.getElementsByTagName('body')[0].clientHeight;
      screenWidth = window.innerWidth || document.documentElement.clientWidth || document.documentElement.getElementsByTagName('body')[0].clientWidth;

      window.addEventListener('mousemove', resize);
      window.addEventListener('mouseup', stopResize);
    })
  })
}

function resize(event) {
  const resizePoint = resizer.getAttribute('data-resizer');

  switch (resizePoint) {
    case 'resize-left':
      resizeLeft(event);
      break;
    case 'resize-right':
      resizeRight(event);
      break;
    case 'resize-bottom':
      resizeBottom(event);
      break;
    case 'resize-top':
      resizeTop(event);
      break;
    case 'resize-top-left':
      resizeTopLeft(event);
      break;
    case 'resize-top-right':
      resizeTopRight(event);
      break;
    case 'resize-bottom-left':
      resizeBottomLeft(event);
      break;
    case 'resize-bottom-right':
      resizeBottomRight(event);
      break;
    default:
      break;
  }
}

function resizeTopLeft(event) {
  const width = chatWidth - (event.pageX - mouseX);
  const height = chatHeight - (event.pageY - mouseY);

  if (width > minSizeWidth && width < CHAT_MAX_WIDTH) {
    element.style.width = `${width}px`;
    element.style.left = `${chatPositionX + (event.pageX - mouseX)}px`;
  }
  if (height > minSizeHeight && event.y > 0) {
    element.style.height = `${height}px`;
    element.style.top = `${chatPositionY + (event.pageY - mouseY)}px`;
  }
}

function resizeTopRight(event) {
  const width = chatWidth + (event.pageX - mouseX);
  const height = chatHeight - (event.pageY - mouseY);

  if (width > minSizeWidth && width < CHAT_MAX_WIDTH) {
    element.style.width = `${width}px`;
  }
  if (height > minSizeHeight && event.y > 0) {
    element.style.height = `${height}px`;
    element.style.top = `${chatPositionY + (event.pageY - mouseY)}px`;
  }
}

function resizeBottomLeft(event) {
  const height = chatHeight + (event.pageY - mouseY);
  const width = chatWidth - (event.pageX - mouseX);

  if (height > minSizeHeight && event.y < screenHeight) {
    element.style.height = `${height}px`;
  }
  if (width > minSizeWidth && width < CHAT_MAX_WIDTH) {
    element.style.width = `${width}px`;
    element.style.left = `${chatPositionX + (event.pageX - mouseX)}px`;
  }
}

function resizeBottomRight(event) {
  const width = chatWidth + (event.pageX - mouseX);
  const height = chatHeight + (event.pageY - mouseY);

  if (width > minSizeWidth && width < CHAT_MAX_WIDTH) {
    element.style.width = `${width}px`;
  }
  if (height > minSizeHeight && event.y < screenHeight) {
    element.style.height = `${height}px`;
  }
}

function resizeTop(event) {
  const height = chatHeight - (event.pageY - mouseY);

  if (height > minSizeHeight && event.y > 0) {
    element.style.height = `${height}px`;
    element.style.top = `${chatPositionY + (event.pageY - mouseY)}px`;
  }
}

function resizeBottom(event) {
  const height = chatHeight + (event.pageY - mouseY);

  if (height > minSizeHeight && event.y < screenHeight) {
    element.style.height = `${height}px`;
  }
}

function resizeLeft(event) {
  const width = chatWidth - (event.pageX - mouseX);

  if (width > minSizeWidth && width < CHAT_MAX_WIDTH) {
    element.style.width = `${width}px`;
    element.style.left = `${chatPositionX + (event.pageX - mouseX)}px`;
  }
}

function resizeRight(event) {
  const width = chatWidth + (event.pageX - mouseX);

  if (width > minSizeWidth && width < CHAT_MAX_WIDTH) {
    element.style.width = `${width}px`;
  }
}

function disableScroll() {
  window.onscroll = function () {
    stopResize();
  };
}

function enableScroll() {
  window.onscroll = function () {
  };
}

export function stopResize() {
  enableScroll();
  window.removeEventListener('mousemove', resize);
  window.removeEventListener('mouseup', stopResize);
}

